import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { Api } from '../../providers/api';
import {GVLogger} from "../../services/gv-logger";
import {fromEvent} from "rxjs/observable/fromEvent";
import {debounceTime} from "rxjs/operators";
import {LoginPage} from "../login/login";
import {MsgManager} from "../../providers/msg-manager";
// $IMPORTSTATEMENT

/**
 * Generated class for the LocationsListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
// $IONICPAGE
@Component({
  selector: 'page-locations-list',
  templateUrl: 'locations-list.html',
})
export class LocationsListPage {

  items = [];
  private searchStatus: boolean = false;
  searchString = "";
  @ViewChild('barcodeFocus') barCodeFocusInput ;

  constructor(public navCtrl: NavController, private msgManager:MsgManager, public navParams: NavParams, private viewCtrl:ViewController, public api:Api, private gVLogger: GVLogger) {
    this.items = this.navParams.get("items");
    this.searchString = this.navParams.get("searchString");
  }

  ionViewDidLoad() {
    this.gVLogger.log('ionViewDidLoad LocationsListPage');
    setTimeout(() => {
      // Keyboard.show() // for android
      // if(!Constants.isWebstore){
      // alert("sada");
      this.barCodeFocusInput.setFocus();
      // }
    },800);
  }

  supplierSelected(selected: string) :void {
    this.viewCtrl.dismiss(selected);
  }

  close(){
    this.viewCtrl.dismiss();
  }

  // ngOnInit() {
  //   fromEvent(this.barCodeFocusInput.nativeElement, 'barcodeFocus')
  //     .pipe(debounceTime(600)) // Adjust the debounce time as needed
  //     .subscribe(event => {
  //       this.onInputChange(event);
  //     });
  // }


  // onInputChange(event: any) {
  //   // event.preventDefault();
  //   event.stopPropagation();
  //   console.log("ECEVENTTT : " + event.target.value)
  //   this.searchStatus = false;
  //   let substring = event.target.value;
  //
  //     if (substring.trim() == "") {
  //       substring = "-1";
  //     }
  //     this.api.get("products/getLocationsByAdpCustomerId/?searchString=" + substring)
  //       .map(res => res.json())
  //       .subscribe(data => {
  //           if (data.status === "200") {
  //             console.log("InSSSSIDDEEEeeeeeeeeeeeeeeee : " +  data.data[0])
  //             console.log("InSSSSIDDEEEeeeeeeeeeeeeeeee : " + substring)
  //             this.items = [];
  //
  //             if(data.data.length ===1){
  //               this.viewCtrl.dismiss(data.data[0]);
  //             }
  //             for (let item of data.data) {
  //               let loc = {name : item.name, locationCode : item.locationCode}
  //               this.items.push(loc);
  //               // this.gVLogger.log("daaaattaaaaa : " + this.items);
  //             }
  //             this.searchStatus = false;
  //             // if(this.items.length === 1){
  //             //   this.viewCtrl.dismiss(this.items[0]);
  //             // }
  //           } else {
  //             this.items = [];
  //             this.searchStatus = true;
  //             // this.gVLogger.log("else case when no data found : " + this.searchStatus);
  //           }
  //       });
  //   // }
  // }


  onInputChange(event: any) {
    event.stopPropagation();
    setTimeout(() => {
      console.log("ECEVENTTT : " + event.target.value)
      this.searchStatus = false;
      let substring = event.target.value;

      if (substring.trim() == "") {
        substring = "-1";
      }
      this.api.get("products/getLocationsByAdpCustomerId/?searchString=" + substring)
        .map(res => res.json())
        .subscribe(data => {
          if(data.status == "401"){ // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

            this.navCtrl.setRoot(LoginPage);
          }
          if (data.status === "200") {
            console.log("InSSSSIDDEEEeeeeeeeeeeeeeeee : " +  data.data[0])
            console.log("InSSSSIDDEEEeeeeeeeeeeeeeeee : " + substring)
            this.items = [];

            if(data.data.length ===1){
              this.viewCtrl.dismiss(data.data[0]);
            }
            for (let item of data.data) {
              let loc = {name : item.name, locationCode : item.locationCode}
              this.items.push(loc);
              // this.gVLogger.log("daaaattaaaaa : " + this.items);
            }
            this.searchStatus = false;
            // if(this.items.length === 1){
            //   this.viewCtrl.dismiss(this.items[0]);
            // }
          } else {
            this.items = [];
            this.searchStatus = true;
            // this.gVLogger.log("else case when no data found : " + this.searchStatus);
          }
        });

    },400);


    // event.preventDefault();


  }

}



// WEBPACK FOOTER //
// ./src/pages/locations-list/locations-list.ts